    <div class="modal-content">
      <div class="modal-header">
        <button type="button" class="close" aria-label="Close" (click)="close()">
          <span aria-hidden="true">X</span>
        </button>
        <storever-header-modal [title]="'SITE_LIST_MERGE_SUBSCRIPTION_SITE'" [icon]="'fal fa-object-group'"></storever-header-modal>
      </div>
<!--      <span *ngIf="selectedItems">-->
<!--        <div [ngClass]="selectedItems?.length > 6 ? 'scroll' : null">-->
<!--         <span style="margin-left: 10px" translate>SITE_LIST_MERGE_CLIENT_SELECTED_SITE_LABEL</span><br>-->
<!--          <span *ngFor="let item of selectedItems" >-->
<!--          <storever-header-subtitle [datas]="[ {icon: 'fal fa-building', title: 'GENERIC_SUBSCRIPTION_NAME', name: item?.name}]-->
<!--          "></storever-header-subtitle>-->

<!--      </span>-->
<!--        </div>-->
<!--      </span>-->
      <span *ngIf="selectedOneItem ; else multiItems">
          <storever-header-subtitle [datas]="[
           {icon: 'fa-map-marker-alt', title: 'GENERIC_SITE', name: selectedOneItem?.name},
           {icon: 'fal fa-box', title: 'GENERIC_PRODUCT', name: selectedOneItem.productName},
           {icon: 'fa-hdd fal', title: 'GENERIC_DEVICE_ID', name: selectedOneItem.deviceId}]"></storever-header-subtitle>
      </span>
      <ng-template #multiItems >
        <!--        <div class="help-block error" *ngIf="!checkProductType()" translate>SUBSCRIPTION_SELECTED_WITH_DIFFERENT_PRODUCT</div>-->
        <div [ngClass]="selectedItem?.length > 6 ? 'scroll' : null" >
          <span *ngFor="let item of selectedItem let i = index " >
          <storever-header-subtitle [isAllowedRemove]="true" [datas]="[
           {icon: 'fa-map-marker-alt', title: 'GENERIC_SITE', name: item?.name},
           {icon: 'fal fa-box', title: 'GENERIC_PRODUCT', name: item.productName},
           {icon: 'fa-hdd fal', title: 'GENERIC_DEVICE_ID', name: item.deviceId}]">
           <i class="fal fa-trash-alt" *ngIf="selectedItem?.length > 1" style="margin-top:6px" tooltip="{{ 'DELETE' | translate:locale.language}}" (click)="removeSubscription(i)"></i>
          </storever-header-subtitle>
          </span>
        </div>
      </ng-template>
      <div class="modal-body">
        <div class="portlet-body">
          <form [formGroup]="form" >
            <storever-element-group
              #elementGroup
              [icon]="'fal fa-hdd'"
              [title]="'none'"
              [config]="formConfig.config"
              [form]="form">
            </storever-element-group>
          </form>
          <br>
          <div style="margin-left: 153px;">--------------------------------OR new site name ----------------------------</div>
          <br>
          <form [formGroup]="newForm" >
            <storever-element-group
              #elementGroup
              [icon]="'fal fa-hdd'"
              [title]="'none'"
              [config]="newFormConfig.config"
              [form]="newForm">
            </storever-element-group>
          </form>
          <div class="help-block error error-msg-padding" *ngIf="error != 'false'" translate="">{{error}}</div>
        </div>
      </div>
      <div class="modal-footer">
<!--       old form: {{form.get('siteName').value}}  new form:{{newForm.get('NewSiteName').value}}-->
        <button *ngIf="form.get('siteName').value && !newForm.get('NewSiteName').value" type="button" class="btn btn-primary" [disabled]="!form.valid" (click)="send()">{{'SITE_LIST_MERGE_SITE_CLIENT_BTN' | translate:locale.language}} </button>
        <button *ngIf="!form.get('siteName').value && newForm.get('NewSiteName').value" type="button" class="btn btn-primary" [disabled]="!newForm.valid || error !== 'false' || !isExist" (click)="sendNew()">{{'SITE_LIST_MERGE_SITE_CLIENT_BTN' | translate:locale.language}} </button>
        <button *ngIf="!form.get('siteName').value && !newForm.get('NewSiteName').value" type="button" class="btn btn-primary" [disabled]="true" (click)="send()">{{'SITE_LIST_MERGE_SITE_CLIENT_BTN' | translate:locale.language}} </button>
        <button *ngIf="form.get('siteName').value && newForm.get('NewSiteName').value" type="button" class="btn btn-primary" [disabled]="true" (click)="send()">{{'SITE_LIST_MERGE_SITE_CLIENT_BTN' | translate:locale.language}} </button>
        <button type="button" class="btn btn-default" (click)="cancel()">{{'CANCEL' | translate:locale.language}}</button>
      </div>
    </div>
